import { defineStore } from "pinia";
import api from "@/services/api";

export const useHomeStatsStore = defineStore("homeStats", {
  state: () => ({
    stats: {
      clients_count: 0,
      consultations_count: 0,
      clients_growth_percent: 0,
      consultations_growth_percent: 0,
      clients_progress_percent: 0,
      consultations_progress_percent: 0,
    },
    loading: false,
    error: null,
    lastFetchedAt: 0,
  }),

  getters: {
    hasStats: (s) => !!s.stats,
  },

  actions: {
    async getStats({ force = false, ttlMs = 60_000 } = {}) {
      const now = Date.now();
      if (!force && now - this.lastFetchedAt < ttlMs) return;

      this.loading = true;
      this.error = null;

      try {
        const res = await api.get("/home-stats");
        const data = res?.data?.data ?? res?.data ?? {};
        this.stats = { ...this.stats, ...data };
        this.lastFetchedAt = now;
      } catch (e) {
        this.error =
          e?.response?.data?.message ||
          e?.message ||
          "Failed to load home stats.";
      } finally {
        this.loading = false;
      }
    },
  },
});
